import { render, staticRenderFns } from "./albi.vue?vue&type=template&id=4849eed3&"
import script from "./albi.vue?vue&type=script&lang=js&"
export * from "./albi.vue?vue&type=script&lang=js&"
import style0 from "./albi.vue?vue&type=style&index=0&id=4849eed3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports